import { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Button from '../../../../common/Button'
import {
  getRequest,
  postRequest,
  putRequest,
} from '../../../../../services/base'
import { NavContext } from '../../../../../context/global_context'
import Modal, { ModalBody, ModalHeader } from '../../../../common/Modal'
import SelectInput from '../../../../common/SelectInput'
import { useParams } from 'react-router-dom'
import useDebouncedValue from '../../../../../utils/common_function'

const DEFAULT_FORM_VALUES = {
  sub_system_data: {},
  sub_system_id: '',
  connector_data: [],
  connector: null,
  sub_system: null,
  sales_code_data: [],
  sales_code: null,
}

const FunctionalDiagramForm = (props) => {
  const [state, dispatch] = useContext(NavContext)
  const { vehicle } = useParams()
  const [subSystemDetails, setSubSystemDetails] = useState(DEFAULT_FORM_VALUES)
  const [subSystemListData, setSubSystemListData] = useState([])
  const [connectorOptionData, setConnectorsOptionData] = useState([])
  const [searchConnector, setSearchConnector] = useState(null)
  const debouncedSearchTerm = useDebouncedValue(searchConnector, 1000)

  const [searchSalesCode, setSearchSalesCode] = useState('')
  const debouncedSearchSalesCode = useDebouncedValue(searchSalesCode, 1000)
  const [salesCodeOptions, setSalesCodeOptions] = useState([])

  useEffect(() => {
    if (props?.selectedFunctionalDiagram?.id) {
      getFunctionalDiagramConnectors()
    } else {
      setSubSystemDetails(DEFAULT_FORM_VALUES)
    }
  }, [props?.selectedFunctionalDiagram])

  useEffect(() => {
    getSubSystemList('')
  }, [])

  useEffect(() => {
    getConnectorOptions(searchConnector ? searchConnector : '')
  }, [debouncedSearchTerm])

  useEffect(() => {
    getSalesCodes()
  }, [debouncedSearchSalesCode])

  const getConnectorOptions = async (searchValue = '') => {
    let response = await getRequest(
      `/api/connector/?search=${searchValue}&vehicle=${vehicle}`
    )
    setConnectorsOptionData(response.results)
  }

  const getFunctionalDiagramConnectors = async () => {
    let sub_system_id = props?.selectedFunctionalDiagram?.id
      ? props?.selectedFunctionalDiagram?.id
      : subSystemDetails?.sub_system_data?.id
    let res = await getRequest(
      `/api/sub_system/functional-diagram-connector/${sub_system_id}/?make=${vehicle}`
    )
    const newExistingConnectors = res.data.map((row) => ({
      ...row,
      id: row.connector_data_id,
    }))
    setSubSystemDetails({
      ...subSystemDetails,
      connector_data: newExistingConnectors,
      sub_system_data: props?.selectedFunctionalDiagram,
      sales_code_data: res?.sales_code,
    })
  }

  const getSubSystemList = async (searchValue = '') => {
    let response = await getRequest(`/api/sub_system/?search=${searchValue}`)
    setSubSystemListData(response.results)
  }

  const saveSystemDetails = async (e) => {
    const form = e.target
    const formData = new FormData(form)
    formData.append('vehicle', vehicle)
    formData.delete('connector')
    formData.delete('sales_code')

    subSystemDetails?.connector_data.forEach((row, index) => {
      formData.append(
        'connector',
        row.connector_data_id ? row?.connector_data_id : row.id
      )
    })
    subSystemDetails?.sales_code_data.forEach((row, index) => {
      formData.append('sales_code', row.id)
    })

    let sub_system_id = props?.selectedFunctionalDiagram?.id
      ? props?.selectedFunctionalDiagram?.id
      : subSystemDetails?.sub_system_data?.id
    let res = await postRequest(
      `/api/sub_system/functional-diagram/${sub_system_id}/`,
      formData
    )

    if (res?.status) {
      setSubSystemDetails({})
      props.onSave()
    } else {
      let msg = ''
      Object.keys(res).map((obj) => {
        if (msg) {
          msg += `, ${res[obj]}`
        } else {
          msg = `${res[obj]}`
        }
      })

      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: msg,
        },
      })
    }
  }

  const getSalesCodes = async () => {
    let res = await getRequest(
      `/api/sales_codes/?vehicle=${vehicle}&search=${searchSalesCode}`
    )
    setSalesCodeOptions(res.results)
  }

  return (
    <Modal
      onClose={() => {
        setSubSystemDetails({})
        props.setShowModal(false)
        props.onClose()
      }}
      show={props.showModal}
    >
      <ModalHeader className={'text-white'}>
        {props.selectedFunctionalDiagram?.id
          ? 'Update Existing Functional Diagram'
          : 'Create New Functional Diagram'}
      </ModalHeader>
      <ModalBody>
        <div className="">
          <form
            onSubmit={(e) => {
              e.preventDefault()
              saveSystemDetails(e)
            }}
          >
            <input
              type="hidden"
              value={props?.selectedFunctionalDiagram?.id ? false : true}
              name="is_create"
            />
            {props?.selectedFunctionalDiagram?.id && (
              <input
                type="hidden"
                name="id"
                value={props?.selectedFunctionalDiagram?.id}
              />
            )}
            <div className="flex">
              <div className="w-full">
                <SelectInput
                  value={
                    subSystemDetails?.sub_system_data?.id
                      ? subSystemDetails?.sub_system_data
                      : null
                  }
                  onChange={(value) => {
                    setSubSystemDetails({
                      ...subSystemDetails,
                      sub_system_data: value,
                    })
                  }}
                  label="Sub System"
                  name="sub_system"
                  isRequired={false}
                  options={subSystemListData}
                  optionLabel={'name'}
                  optionValue={'id'}
                  onInputChange={(value) => {
                    getSubSystemList(value)
                  }}
                />
              </div>
            </div>
            <div className="flex">
              <div className={`w-full`}>
                <SelectInput
                  value={
                    subSystemDetails?.connector_data?.length > 0
                      ? subSystemDetails?.connector_data
                      : []
                  }
                  onChange={(value) => {
                    setSubSystemDetails({
                      ...subSystemDetails,
                      connector_data: value,
                    })
                  }}
                  label="Connector"
                  name="connector"
                  isRequired={false}
                  options={connectorOptionData}
                  onInputChange={(value) => {
                    if (value) {
                      setSearchConnector(value)
                    }
                  }}
                  isMulti={true}
                  formatOptionLabel={(option) => (
                    <>
                      <div className="font-extrabold">{option.name}</div>
                      <div>{option.description}</div>
                    </>
                  )}
                  optionLabel={'name'}
                  optionValue={'id'}
                  isClearable={true}
                />
              </div>
            </div>

            <div className="flex">
              <div className={`w-full`}>
                <SelectInput
                  value={
                    subSystemDetails?.sales_code_data?.length > 0
                      ? subSystemDetails?.sales_code_data
                      : []
                  }
                  onChange={(value) => {
                    setSubSystemDetails({
                      ...subSystemDetails,
                      sales_code_data: value,
                    })
                  }}
                  label="Sales Code"
                  name="sales_code"
                  isRequired={false}
                  options={salesCodeOptions}
                  onInputChange={(value) => {
                    if (value) {
                      setSearchSalesCode(value)
                    }
                  }}
                  isMulti={true}
                  formatOptionLabel={(option) => (
                    <>
                      <div className="font-extrabold">{option.name}</div>
                      <div>
                        {option.description} ({option?.group?.name})
                      </div>
                    </>
                  )}
                  optionLabel={'name'}
                  optionValue={'id'}
                  isClearable={true}
                />
              </div>
            </div>
            <div className="flex justify-end">
              <Button
                type="submit"
                className={`cursor-pointer btn my-4 justify-end`}
                onClick={(e) => {}}
                value={'text'}
                text={
                  props.selectedFunctionalDiagram?.id
                    ? 'Save Functional Diagram'
                    : 'Create New Functional Diagram'
                }
              />
            </div>
          </form>
        </div>
      </ModalBody>
    </Modal>
  )
}

FunctionalDiagramForm.propTypes = {
  selectedFunctionalDiagram: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  setShowModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
}

export default FunctionalDiagramForm
